import React from 'react'
import { Box, BoxProps } from '@ritualco/jutsu'

export const CanvasBox = React.forwardRef<HTMLCanvasElement, BoxProps>(
  (props, ref) => (
    <Box
      border="1px solid"
      borderColor="grayscale.quinary"
      borderRadius="lg"
      p={5}
      display="inline-block"
      {...props}
    >
      <canvas ref={ref} />
    </Box>
  )
)
